import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import styles from './input.scss';

const propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  id: PropTypes.string.isRequired,
  errors: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
      PropTypes.object, // sometimes extra keys are added to the error
    ]),
  ),
  explanation: PropTypes.string,
  inputRef: PropTypes.func,
  unsaved: PropTypes.bool,
  disabled: PropTypes.bool,
  stretch: PropTypes.bool,
};

const Input = (props) => {
  const {
    inputRef,
    unsaved,
    stretch,
    ...inputProps
  } = props;

  return (
    <div className={classNames(
      styles.input,
      { [styles.stretch]: stretch },
    )}
    >
      <label
        htmlFor="name"
        className={props.disabled ? styles.disabled : ''}
      >
        {props.label}
        {unsaved ? (<span className={styles.unsaved}> unsaved</span>) : ''}
      </label>
      <input
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        {...inputProps}
        ref={inputRef}
      />
      {
        props.errors && props.errors[props.id]
        && (
        <span className={styles.validationError}>
          { typeof props.errors[props.id] === 'string'
            ? <span>{props.errors[props.id]}</span>
            : (
              <span>
                { props.errors[props.id].map((error) => (
                  <span key={error}>
                    {error}
                  </span>
                ))}
              </span>
            )}
        </span>
        )
      }
      { props.explanation
        && (
        <span className={styles.explanation}>
          {props.explanation}
        </span>
        )}
    </div>
  );
};

Input.propTypes = propTypes;

export default Input;
